import type { HomeInvestmentStyleDiagnosisStatus } from "../hooks/useHomeInvestmentStyleDiagnosis";

// ホームの投資スタイル診断ミニ表示セクションの「表示可否」の定義元。
// 表示は診断GETの結果（status）だけで決め、サーバフラグは表示判定に使わない
// （フラグは診断レコードの写しにすぎず、別端末での診断完了などで実データと乖離しうるため）。
// 相性の良いプランナーセクションは登録時に必須の投資力診断で採点されるため、
// 投資スタイル診断の状態には依存せず常に取得・表示する（ここでは判定しない）。

// 投資スタイル診断のミニ表示セクションの表示可否。
// 判定前（loading）と、401・500 等で診断状態が分からないとき（unavailable）は表示しない
// （未診断と誤って案内しないため）。未診断は診断導線バナーを出すので表示する
export const canShowStyleDiagnosisSection = (status: HomeInvestmentStyleDiagnosisStatus): boolean =>
  status === "diagnosed" || status === "undiagnosed";
